import { Model } from '@lernetz/ts-lib';

export class Asset extends Model {
    height: number;
    width: number;
}
